import React, { Component } from "react";
import "w3-css/3/w3.css";

class FromMachButton extends Component {
  handleClickButon = buttonId => {
    this.props.maUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Mach to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <MPHButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KnotsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KPHButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromMPHButton extends Component {
  handleClickButon = buttonId => {
    this.props.mpUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Mile Per Hour to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <MachButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KnotsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KPHButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromKnotsButton extends Component {
  handleClickButon = buttonId => {
    this.props.knUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Knot to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <MachButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MPHButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KPHButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromKPHButton extends Component {
  handleClickButon = buttonId => {
    this.props.kpUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Kilometer Per Hour to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <MachButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MPHButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KnotsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class MachButton extends Component {
  handleUpButton = () => {
    let name = "ma";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="mach"
        >
          Maches
        </button>
      </span>
    );
  }
}

class MPHButton extends Component {
  handleUpButton = () => {
    let name = "mp";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="mph"
        >
          Miles Per Hour
        </button>
      </span>
    );
  }
}

class KnotsButton extends Component {
  handleUpButton = () => {
    let name = "kn";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="knots"
        >
          Knots
        </button>
      </span>
    );
  }
}

class KPHButton extends Component {
  handleUpButton = () => {
    let name = "kp";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="kph"
        >
          Kilometers Per Hour
        </button>
      </span>
    );
  }
}

export { FromMachButton, FromMPHButton, FromKnotsButton, FromKPHButton };
